import React from 'react';
import { useParams } from 'react-router-dom';

import { useGetDisplayCategoryById } from '@occc-app/dataAccessLayer/displayCategory/queries';

import { DisplayCategoryDetailsPage } from './DisplayCategoryDetailsPage';

export const DisplayCategoryDetailsPageContainer: React.FC = () => {
  const { id: displayCategoryId = '' } = useParams<{ id: string }>();
  const {
    loading,
    error,
    data: { bannerConfigurations, displayCategory },
  } = useGetDisplayCategoryById(displayCategoryId);

  return (
    <DisplayCategoryDetailsPage
      loading={loading}
      error={error}
      displayCategory={displayCategory}
      externalBanners={bannerConfigurations}
    />
  );
};
